/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'teamsMessageTrace';

/** API route prefix — shared by `model.js` and list descriptor routes. */
export const FETCH_ROUTE = 'teamsMessageTrace';

/** Singular entity name for notifications / shared helpers. */
export const ENTITY_NAME = 'teamsMessageTrace';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'teamsMessageTraces';

/** Default OData sort when the user clears column sorting. */
export const DEFAULT_ORDER_BY = 'created desc';
